import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import TimeTrackingContainer from '../components/TimeTracking/TimeTrackingContainer';

    class TimeTracking extends React.Component {

      componentDidMount = () => {
        this.props.log('TimeTracking.js/componentDidMount');
      }
    
      render() {
        return (<Container fluid>
          <TimeTrackingContainer {...this.props}/>
        </Container>
        );
      }
    }

export default TimeTracking;